export default {
      id: "command__follow-usage",
      viewBox: "2 2 20 20",
      url: __webpack_public_path__ + "img/icons.svg#command__follow",
      toString: function () {
        return this.url;
      }
    }